import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosLink } from "react-icons/io";

interface Props {
  className?: string;
  onCopy?: () => void;
  text: string;
}

const CopyToClipboard = ({
  className = "",
  text,
  onCopy = () => {},
}: Props) => {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1200);
        onCopy();
      })
      .catch(() => console.error("CopyToClipboard ERROR"));
  }

  const buttonSize = 28; // fixed size

  return (
    <button
      onClick={copy}
      title="Copy text"
      className={`relative flex items-center justify-center p-1 rounded transition ${className}`}
      style={{ width: `${buttonSize}px`, height: `${buttonSize}px` }}
    >
      {/* Tooltip / "Copied" text */}
      <AnimatePresence>
        {copied && (
          <motion.span
            key="tooltip"
            className="absolute -top-6 text-xs font-semibold text-green-500 font-sans bg-white px-2 py-1 rounded shadow-md"
            initial={{ y: 10, opacity: 0, scale: 0.7 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -10, opacity: 0, scale: 0.7 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            Copied
          </motion.span>
        )}
      </AnimatePresence>

      {/* Icon wrapper for motion */}
      <motion.span
        key="icon"
        className={`text-lg flex items-center justify-center transition-colors ${
          copied ? "text-green-500" : "text-gray-700"
        }`}
        initial={{ scale: 0.8 }}
        animate={{ scale: copied ? 1.2 : 1 }}
        transition={{ type: "spring", stiffness: 400, damping: 20 }}
      >
        <IoIosLink />
      </motion.span>
    </button>
  );
};

export default CopyToClipboard;
